let loginRes = {};
let msalInitilized = false;
let attachmentData = {};
const tabViewObj = {};
let graphModalObj = {};
let txnFormData = {};
let homeCalendarData = {};
let txnNotificationModalData = {};
let isScriptLoad = false;
let isSubformScriptLoad = {};
let dataModeGraphDashboardData = {};
let subFormAttachmentData = {};
let selectedLookupData = {};
let pAccessId = '';
let sourceTxnData = {};
let hideFieldsArray = [];
let savedFilterInfo = '';
let optionSetinfo = {};
let filterPaylodaData = {};
let txnMode = '';
let lookupFilterData = {};
let selectedOwnerData = {};
let mode = '';
let selectedUserRole = {
  perspectiveId: '',
  label: '',
  id: '',
  view: {},
  allowDataImport: false,
};
let reloadFilters = true;
let reloadFiltersFlagInProgress = false;
let serviceFilterList = [];
let transactionCopyData = {
  txnData: null,
  fieldsData: null,
};
let isPublicForm = false;
let publicFormErrorMessage = '';
let isTxnNewFromRelatedList = false;

export const setLoginRes = (resp) => {
  loginRes = resp;
};

export const getLoginRes = () => {
  return loginRes;
};

export const getLoginAccessToken = () => {
  return loginRes?.access_token;
};

export const getLoginRefreshToken = () => {
  return loginRes?.refresh_token;
};

export const getLoginBusinessId = () => {
  return loginRes['x-business-id'];
};

export const getLoginAccountId = () => {
  return loginRes?.account_id;
};

export const getLoginUserEmail = () => {
  return loginRes['x-username'];
};

export const setMsalInitilized = (isInit) => {
  msalInitilized = isInit;
};

export const getMsalInitilized = () => {
  return msalInitilized;
};
// setting the attachments data.
export const setAttachmentsData = (attachments) => {
  attachmentData = attachments;
};

// setting the attachments data.
export const getAttachmentsData = () => {
  return attachmentData;
};

export const setRelatedListTab = (parentSvcType, activeTab, txnId) => {
  if(activeTab){
    tabViewObj[parentSvcType] = {activeTab, txnId};
  }else {
    delete tabViewObj[parentSvcType];
  }
};

export const getRelatedListTab = () => {
  return tabViewObj;
};

export const setTxnNewFromRelatedListTab = (value) => {
  isTxnNewFromRelatedList = value;
};

export const getTxnNewFromRelatedListTab = () => {
  return isTxnNewFromRelatedList;
};

export const setGraphModalData = (modalGraphDataObj) => {
  graphModalObj = modalGraphDataObj;
};

export const getGraphModalData = () => {
  return graphModalObj;
};
// setting the txn form data.
export const setTxnFormData = (txnForm) => {
  txnFormData = txnForm;
};

// getting the txn form data.
export const getTxnFormData = () => {
  return txnFormData;
};

export const setHomeCalendarData = (homeCalendar) => {
  homeCalendarData = homeCalendar;
};

export const getHomeCalendarData = () => {
  return homeCalendarData;
};

export const setTxnNotificationModalData = (txnModalDataObj) => {
  txnNotificationModalData = txnModalDataObj;
};

export const getTxnNotificationModalData = () => {
  return txnNotificationModalData;
};

export const setIsScriptLoad = (isFromScriptLoad) => {
  isScriptLoad = isFromScriptLoad;
};

export const getIsScriptLoad = () => {
  return isScriptLoad;
};

export const setIsSubformScriptLoad = (isFromScriptLoad) => {
  isSubformScriptLoad = isFromScriptLoad;
};

export const getIsSubformScriptLoad = () => {
  return isSubformScriptLoad;
};

export const setDataModeDashboardInfo = (dataModeInfo) => {
  dataModeGraphDashboardData = dataModeInfo;
};

export const getDataModeDashboardInfo = () => {
  return dataModeGraphDashboardData;
};
// setting the attachments data.
export const setSubFormAttachmentsData = (attachments) => {
  subFormAttachmentData = attachments;
};

// getting the attachments data.
export const getSubFormAttachmentsData = () => {
  return subFormAttachmentData;
};

// setting the lookup field data.
export const setSelectedLookupFormData = (lookupData) => {
  selectedLookupData = lookupData;
};

// getting the txn form data.
export const getSelectedLookupFormData = () => {
  return selectedLookupData;
};

// setting pacessID
export const setPaccessId = (id) => {
  pAccessId = id;
};

// getting pacessID
export const getPaccessId = () => {
  return pAccessId;
};

// setting the txn form data.
export const setSourceTxnData = (txnData) => {
  sourceTxnData = txnData;
};

// getting the txn form data.
export const getSourceTxnData = () => {
  return sourceTxnData;
};

// setting the hide fields array.
export const setHideFieldsArray = (fields) => {
  hideFieldsArray = fields;
};

// getting the hide fields array
export const getHideFieldsArray = () => {
  return hideFieldsArray;
};

// setting the saved filter data
export const setSavedFilterData = (filterInfo) => {
  savedFilterInfo = filterInfo;
};

// getting the saved filter data
export const getSavedFilterData = () => {
  return savedFilterInfo;
};

// setting the saved filter data
export const setOptionSetFiltedData = (filterInfo) => {
  optionSetinfo = filterInfo;
};

// getting the saved filter data
export const getOptionSetFiltedData = () => {
  return optionSetinfo;
};

// setting the saved filter data
export const setFilterPayloaddData = (filterInfo) => {
  filterPaylodaData = filterInfo;
};

// getting the saved filter data
export const getFilterPayloaddData = () => {
  return filterPaylodaData;
};

// setting the saved filter data
export const setTxnModeState = (mode) => {
  txnMode = mode;
};

// getting the saved filter data
export const getTxnModeState = () => {
  return txnMode;
};

// setting the lookup filter data
export const setSelectedLookupSelectedData = (filterInfo) => {
  lookupFilterData = filterInfo;
};

// getting the lookup filter data
export const getSelectedLookupSelectedData = () => {
  return lookupFilterData;
};

// setting the lookup filter data
export const setSelectedOwnerdData = (ownerData) => {
  selectedOwnerData = ownerData;
};

// getting the lookup filter data
export const getSelectedOwnerdData = () => {
  return selectedOwnerData;
};

// setting the saved filter data
export const setModeState = (modeState) => {
  mode = modeState;
};

// getting the saved filter data
export const getModeState = () => {
  return mode;
};

// getting selected user role (perspective)
export const getselectedUserRole = () => {
  return selectedUserRole;
};

// setting selected user role (perspective)
export const setselectedUserRole = (role) => {
  selectedUserRole = role;
};

// getting reloadFilters flag
export const getReloadFilters = () => {
  return reloadFilters;
};

export const resetReloadFiltersFlag = () => {
  if (!reloadFiltersFlagInProgress) {
    reloadFiltersFlagInProgress = true;
    setTimeout(() => {
      reloadFilters = true;
      reloadFiltersFlagInProgress = false;
    }, 500);
  }
};

// setting reloadFilters flag
export const setReloadFilters = (flag) => {
  reloadFilters = flag;
}

export const setServiceFilterListGlobal = (filterList) => {
  serviceFilterList = filterList;
}

export const getServiceFilterListGlobal = () => {
  return serviceFilterList;
}

export const setTransactionCopyData = (data) => {
  transactionCopyData = {
    txnData: data,
    fieldsData: data?.copyFields,
  };
};

export const getTransactionCopyData = () => {
  return transactionCopyData;
};

export const clearTransactionCopyData = () => {
  transactionCopyData = {
    txnData: null,
    fieldsData: null,
  };
};

export const setIsPublicFormLoaded = (isForm) => {
  isPublicForm = isForm;
}

export const getIsPublicFormLoaded = () => {
  return isPublicForm;
}

export const setPublicFormErrorMessage = (msg) => {
  publicFormErrorMessage = msg;
}

export const getPublicFormErrorMessage = () => {
  return publicFormErrorMessage;
}